/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import {service as SurveyQuestionSecondaryFieldRequiredService} from "../../../Services/SurveyQuestionSecondaryFieldRequiredService";
import autobind from "autobind-decorator";
import {FormControl} from "react-bootstrap";
import React from "react";

export class SurveyQuestionSecondaryFieldRequiredFieldEditor extends BaseFieldEditor {
	constructor(props) {
		super(props)

		this.setInitialState({
			surveyQuestionSecondaryFieldRequireds: []
		});
	}

	componentDidMount() {
		SurveyQuestionSecondaryFieldRequiredService.Get()
			.then((x) => {
				this.setState({surveyQuestionSecondaryFieldRequireds: x.result});
			});
	}

	@autobind
	_render() {
		return <FormControl
			as="select"
			placeholder="Select"
			value={this.props.Value || ""}
			onChange={(x) => this.props.OnUpdate(x.target.value)}
		>
			<option value="">Select</option>
			{
				this.state.surveyQuestionSecondaryFieldRequireds
					.map((x) => {
						return <option key={x.surveyQuestionSecondaryFieldRequiredId}
						               value={x.surveyQuestionSecondaryFieldRequiredId}>{x.name}</option>;
					})
			}
		</FormControl>;
	}
}